// extracted by mini-css-extract-plugin
module.exports = {"teamRoles":"TeamRoles_teamRoles__qng3b","label":"TeamRoles_label__dYR_M"};